/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RepeatOptions
 */
export interface RepeatOptions {
    /**
     * 
     * @type {number}
     * @memberof RepeatOptions
     */
    number?: number;
    /**
     * 
     * @type {string}
     * @memberof RepeatOptions
     */
    unit?: string;
}

/**
 * Check if a given object implements the RepeatOptions interface.
 */
export function instanceOfRepeatOptions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RepeatOptionsFromJSON(json: any): RepeatOptions {
    return RepeatOptionsFromJSONTyped(json, false);
}

export function RepeatOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepeatOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'number': !exists(json, 'number') ? undefined : json['number'],
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
    };
}

export function RepeatOptionsToJSON(value?: RepeatOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'number': value.number,
        'unit': value.unit,
    };
}

